import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const overViewApi = createApi({
  baseQuery,
  reducerPath: 'overViewApi',
  endpoints: builder => ({
    getOverviewKit: builder.query<any, any>({
      query: ({ site_id, study_id, country, data, application, kit_id, from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.Overview.getAll,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.kit_id, value: kit_id }
        )}?country=${country}&application=${application}${from > -1 ? `&from=${from}` : ''}${
          size > -1 ? `&size=${size}` : ''
        }`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getAllDespended: builder.query<any, any>({
      query: ({ site_id, study_id, country, data, application, kit_id, from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.Overview.getAllDisepended,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.kit_id, value: kit_id }
        )}?country=${country}&application=${application}${from > -1 ? `&from=${from}` : ''}${
          size > -1 ? `&size=${size}` : ''
        }`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createDARNotes: builder.mutation<any, any>({
      query: ({ event_id, country, application, site_id, data }) => ({
        url: `${formatString(endPoints.Overview.DARNotesCreate, {
          key: urlKeys.event_id,
          value: event_id
        })}?country=${country}&application=${application}&site_id=${site_id}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useLazyGetOverviewKitQuery, useLazyGetAllDespendedQuery, useCreateDARNotesMutation } = overViewApi;
